export function isMobile() {
    const ua = navigator.userAgent.toLowerCase();
    return /android|webos|iphone|ipod|ipad|blackberry|iemobile|opera mini/i.test(ua);
}
